// Light theme: original logo inside a white box (unchanged).
// Dark theme: white-text logo on a transparent background.
// The swap is pure CSS driven by the `dark` class on <html>, so it
// updates instantly when the theme toggles (no reload).
export function Logo({ className = "h-9", boxed = true }) {
  const imgs = (
    <>
      <img
        src="/arrow-logo.webp"
        alt="Arrow Express"
        className={`${className} dark:hidden`}
        data-testid="arrow-logo"
      />
      <img
        src="/arrow-logo-dark.webp"
        alt="Arrow Express"
        className={`${className} hidden dark:block`}
        data-testid="arrow-logo-dark"
      />
    </>
  );
  if (!boxed) return <span className="inline-flex items-center">{imgs}</span>;
  return (
    <div className="bg-white dark:bg-transparent rounded-sm px-2.5 py-1.5 dark:px-0 inline-flex items-center">
      {imgs}
    </div>
  );
}
